import React from 'react';
/**
 * DrawerGroup provides basic styles to child Drawers
 *
 * @example
 * <DrawerGroup>
 *   <Drawer>
 *     <Drawer.Title>First Drawer</Drawer.Title>
 *     <Drawer.Content>
 *       <ul>
 *         <li>Item 1</li>
 *         <li>Item 2</li>
 *         <lit>Item 3</li>
 *       </ul>
 *     </Drawer.Content>
 *   </Drawer>
 *
 *   <Drawer>
 *     <Drawer.Title>Second Drawer</Drawer.Title>
 *     <Drawer.Content>
 *       <ul>
 *         <li>Item 1</li>
 *         <li>Item 2</li>
 *         <lit>Item 3</li>
 *       </ul>
 *     </Drawer.Content>
 *   </Drawer>
 * </DrawerGroup>
 *
 * @class      DrawerGroup
 * @param      {<Drawer>}  children  A collection of Drawer components
 * @return     {<DrawerGroup>}
 */
const DrawerGroup = ({ children }) => (
  <div className="DrawerGroup">{children}</div>
);

export default DrawerGroup;
